import { useTranslation } from "@luckymenu/i18n/react";

export function Brand() {
	const { t } = useTranslation("admin");
	return (
		<span className="flex items-center gap-2 font-semibold text-foreground">
			<img src="/favicon.svg" alt="" className="size-7" />
			<span>{t("productName")}</span>
		</span>
	);
}
